<template>
  <div class="modify-pass-form">
    <div class="title">
      <i class="el-icon-unlock"></i>
      修改密码
    </div>
    <el-form ref="editForm" :model="editForm" label-width="0">
      <el-form-item prop="oldPassword" :rules="{required: true, message:'旧密码不能为空', trigger: 'blur'}">
        <el-input type="password" v-model="editForm.oldPassword" size="large"
                  maxlength="50"
                  minlength="6"
                  placeholder="请输入原始密码">
          <template slot="prepend">原始密码</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="newPassword" :rules="{required: true, message:'新密码不能为空', trigger: 'blur'}">
        <el-input type="password" v-model="editForm.newPassword" size="large"
                  maxlength="50"
                  minlength="8"
                  placeholder="请输入新密码">
          <template slot="prepend">新密码　</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="confirmPassword" :rules="[{required: true, message:'确认密码不能为空', trigger: 'blur'},{validator: twoPassCheck}]">
        <el-input type="password" v-model="editForm.confirmPassword" size="large"
                  maxlength="50"
                  minlength="8"
                  placeholder="请再次输入新密码">
          <template slot="prepend">确认密码</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="verifyCode">
        <div class="random-code-item" :rules="{required: true, message:'验证码不能为空', trigger: 'blur'}">
          <el-input type="text" v-model="editForm.verifyCode" size="large"
                    :minlength="1" :maxlength="6"
                    placeholder="请输入验证码" @keypress.native="enterPress">
            <template slot="prepend">验证码　</template>
          </el-input>
          <el-tooltip content="点击更换验证码" effect="light">
            <el-image fit="fill"
                      :src="globalConfig.apiRoot+'/login/v2/random-code-image?_t='+time"
                      @click="time = new Date().getTime()">
              <span slot="placeholder">loading...</span>
            </el-image>
          </el-tooltip>
        </div>
      </el-form-item>
    </el-form>
    <el-button type="primary" style="width: 100%" :loading="loading" @click="save">确认修改</el-button>
  </div>
</template>

<script>

import BaseVue from "@/components/base/BaseVue";
import CodeSelect from "@/components/base/CodeSelect";
import OrgSelect from "@/components/base/CompSelect";
import AreaCascader from "@/components/base/AreaCascader";
import OrgInput from "@/components/base/OrgInput";

export default {
  extends: BaseVue,
  components: {OrgInput, AreaCascader, OrgSelect, CodeSelect},

  data() {
    return {
      time: new Date().getTime(),
      editForm: {
        confirmPassword: '',
        newPassword: '',
        oldPassword: '',
        verifyCode: ''
      }
    }
  },
  methods: {
    save() {
      const form = this.$refs["editForm"];
      form.validate((success)=>{
        if(!success) {
          return;
        }
        this.loading = true
        this.postForm("/login/v2/modify-password", {
          newPassword: this.encryptSm4(this.editForm.newPassword),
          oldPassword: this.encryptSm4(this.editForm.oldPassword),
          verifyCode: this.editForm.verifyCode
        }, true).then((dr)=> {
          this.editForm = {}
        }).catch((dr)=>{
          this.time = new Date().getTime();
        }).finally(()=>{
          this.loading = false
        });
      });
    },
    enterPress(e) {
      if(e.key == "Enter") {
        this.save();
      }
    },
    twoPassCheck(rule,value,callback) {
      this.editForm.newPassword == this.editForm.confirmPassword ? callback() : callback(new Error('两次密码输入不一致'));
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../css/variables";
  .modify-pass-form{
    width: 377px;
    height: 334px;
    margin: auto;
    background-color: #fff;
    border: 1px solid #fff;
    border-radius: 6px;
    padding: 17px 36px;
    box-sizing: border-box;
    z-index: 99;
    position: relative;
    text-align: left;

    .title {
      font-size: 20px;
      color: #004080;
      letter-spacing: 0;
      margin-bottom: 24px;
    }

    .random-code-item {
      display: flex;
      justify-content: left;
      align-items: center;

      .el-image {
        width: 90px;
        height: 40px;
        margin-left: 5px;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        cursor: pointer;
      }
    }
  }
</style>
